'use client';

import { Suspense } from 'react';
import { PlashkaPriglasheniya } from '@/components/aisearch/partneram/plashka-priglasheniya';
import { useTranslations } from 'next-intl';
import { ShapkaVhoda } from '@/components/features/shapka-vhoda';
import { useSearchParams } from 'next/navigation';
import { ShieldCheck } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { FlowForm } from '@/components/features/flow-form';
import { VhodYandex } from '@/components/features/vhod-yandex';
import { putVozvrata } from '@/lib/vozvrat-posle-vhoda';

function LoginCard() {
  const t = useTranslations('login');
  const tr = useTranslations('register');
  const searchParams = useSearchParams();

  // Middleware кладёт сюда исходный адрес, чтобы вернуть человека туда,
  // куда он шёл до проверки авторизации.
  //
  // Значение из адреса, то есть от кого угодно: пропускаем только свой
  // путь, иначе вход становился бы переадресацией на чужой сайт.
  const syroj = searchParams.get('callbackUrl');
  const callbackUrl = putVozvrata(syroj);
  // Выбор покупки (и любой другой адрес возврата) не теряется, если
  // человек передумал входить и пошёл регистрироваться или вспоминать
  // пароль: адрес едет и туда.
  const sVozvratom = (path: string) => (syroj ? { pathname: path, query: { callbackUrl } } : path);

  return (
    <div className="w-full max-w-md">
      <div className="bg-[var(--color-bg-card)] border border-[var(--color-border)] rounded-2xl p-8 shadow-xl">
        <div className="text-center mb-8">
          <ShapkaVhoda
            znachok={<ShieldCheck className="w-6 h-6 text-[var(--color-brand-400)]" />}
          />
          <p className="text-[var(--color-text-muted)]">{t('subtitle')}</p>
        </div>

        <FlowForm kind="authentication" callbackUrl={callbackUrl} />

        {/* Только на aisearch.ru, на других доменах компонент ничего не рисует. */}
        <VhodYandex callbackUrl={callbackUrl} />

        {/* Регистрация и восстановление теперь тоже на нашем домене. */}
        <div className="mt-6 pt-6 border-t border-[var(--color-border)] space-y-2 text-center text-sm">
          <p className="text-[var(--color-text-muted)]">
            {t('no_account')}{' '}
            <Link
              href={sVozvratom('/register')}
              className="text-[var(--color-accent-400)] hover:underline"
            >
              {tr('title')}
            </Link>
          </p>
          <p>
            <Link
              href={sVozvratom('/recover')}
              className="text-[var(--color-text-muted)] hover:text-[var(--color-accent-400)] transition-colors"
            >
              {t('forgot')}
            </Link>
          </p>
        </div>

        <p className="text-xs text-[var(--color-text-muted)] text-center mt-6">{t('footer')}</p>
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <main className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center p-8">
      {/* Только aisearch.ru, по метке приглашения и при включённой программе. */}
      <PlashkaPriglasheniya />
      <Suspense fallback={null}>
        <LoginCard />
      </Suspense>
    </main>
  );
}
